import Vue from 'vue'
import YoutubeApi from '../apis/youtube'
export const state = () => ({
  id: "",
  token: ""
});
export const actions = {
  async create({ commit, state }, tags) {
    var tag_names = tags.map(tag => {
      return tag.text
    })
    console.log("tag_names", tag_names)
    return await YoutubeApi.create({
      token: state.token,
      tag_names: tag_names,
    })
  },
}
export const mutations = {
  setId(state, id){
    state.name = id
  },
  setToken(state, token){
    state.token = token
  }
}
export const getters = {}

export default {
    namespaced: true,
    state,
    actions,
    mutations,
    getters
}
